import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { fetchDataActive, postData, fetchData, fetchData1, fetchEventincomeExpenseData, fetchDataAccountsIncomeExpense } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import { TableCell, TableContainer, Tooltip, Paper, Table, TableHead, TableBody, TableRow } from '@mui/material';
//import Modal from 'react-modal';


const PRCreate = (props) => {


    const history = useHistory();

    const { isAuthenticated, clubId, branchId, userId, logout, token } = useAuth();
    const [billNo, setBillNo] = useState("");
    const [billDate, setBillDate] = useState("");
    const [amount, setAmount] = useState("");
    const [feesype, setfeesType] = useState(null);
    const [paymentType, setPaymentType] = useState('0');
    const [ispayment, setIsPayment] = useState(true);
    const [ischeck, setIsCheck] = useState(false);
    const [type, setType] = useState("");
    const [incomeexpenseid, setIncomeExpenseId] = useState("");
    const [eventId, setEventId] = useState("");
    const [memberId, setMemberId] = useState("0");
    const [dues, setDues] = useState("");
    const [feesId, setFeesDescriptionId] = useState("");
    const [partId, setPartyId] = useState("");
    const [description, setDescription] = useState("");

    const [chequeNo, setChequeNo] = useState("");
    const [chequeDate, setChequeDate] = useState("");
    const [bankId, setBankId] = useState("");
    const [isSubmit, setIsSubmit] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isSave, setIsSave] = useState(false);
    const [memberOptions, setMemberOptions] = useState([]);
    const [selectedMember, setSelectedMember] = useState(""); // Store selected member ID
    const [originalDuesList, setOriginalDuesList] = useState([]);
    const [eventslist, setEventOptions] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState(""); // Store selected member ID
    // const [selectedEventName, setEventName] = useState("");

    // const [selectedHead, setHead] = useState("");

    const [incomelist, setIncomeOptions] = useState([]);
    const [expenselist, setExpenseOptions] = useState([]);

    const [eventheadincomelist, setEventHeadIncomeOptions] = useState([]);
    const [eventheadexpenselist, setEventHeadExpenseOptions] = useState([]);
    // const [selectedIncomeOrExpense, setSelectedIncomeOrExpense] = useState(""); // Store selected member ID

    const [eventincomelist, setEventIncomeOptions] = useState([]);
    const [eventexpenselist, setEventExpenseOptions] = useState([]);
    // const [selectedEventIncome, setSelectedEventIncome] = useState("");
    // const [selectedEventExpense, setSelectedEventExpense] = useState("");
    // const [dueslist, setDuesList] = useState([]); // Default as empty array
    const [dueslist, setDuesList] = useState([]);
    const [feeslist, setFeesOptions] = useState([]);
    const [selectedfees, setSelectedFees] = useState("");

    const [partylist, setPartyOptions] = useState([]);
    const [selectedParty, setSelectedParty] = useState("");


    const [banklist, setBankOptions] = useState([]);
    const [selectedbank, setSelectedBank] = useState("");

    const [searchTerm, setSearchTerm] = useState(''); // New state for the search term

    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1;
    const currentFinancialYear = currentMonth >= 4 ? `${currentYear}-${currentYear + 1}` : `${currentYear - 1}-${currentYear}`;
    const [memberfinancialyear, setmemberFinancialYear] = useState("");
    //const [data, setData] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [clubIncomeExpenseOption, setClubIncomeExpenseOption] = useState(null); // For Club Income/Expense
    const [eventHeadOption, setEventHeadOption] = useState(null); // For Event Head
    const [eventIncomeExpenseOption, setEventIncomeExpenseOption] = useState(null);
    const [eventIncomeExpenseOption1, setEventIncomeExpenseOption1] = useState(null);
     const [advanceamount, setAdvanceAmount] = useState("");
    // Options for the dropdown
    const options = [
        { value: 1, label: 'Club Income/Expense' },
        { value: 2, label: 'Club Event' },
        { value: 3, label: 'Members' },
        { value: 4, label: 'Others' },
    ];

    const options1 = [
        { value: '0', label: 'Cash' },
        { value: '1', label: 'Cheque' },
        { value: '2', label: 'UPI' },
        { value: '3', label: 'Bank Transfer' },
    ];

    // Use effect to fetch bank list when ischeck becomes true
    useEffect(() => {
        if (paymentType == '1' || paymentType == '2'|| paymentType == '3') {
            fetchBank();

        }
    }, [paymentType, selectedOption]); // Only runs when ischeck changes

    useEffect(() => {

        fetchBank();
    });

    useEffect(() => {
        // Calculate the total balance whenever dueslist changes
        const totalBalance = dueslist.reduce((total, member) => {
            return total + parseFloat(member.balanceAmount || 0);
        }, 0);

        // Set the calculated total balance to the dues field
        setDues(totalBalance);
        //fetchBank();
    }, [dueslist]);

    useEffect(() => {
        fetchBillno();
         fetchBank();
    }, [ispayment]);

    const fetchBillno = async () => {
        try {
            const response = await fetchData('PaymentAndReceiptApi', `/GetBillNo/${clubId}/${branchId}/${ispayment}`, token);  // Capture the result of fetchData
            if (response.responseCode === '1111') {
                setBillNo(response.response_data.billno);
            }
        } catch (error) {
            console.error('Error fetching Fees:', error);
        }
    };

    const handleOptionChange = (option) => {
        setSelectedOption(option);
        setfeesType("");
        if (option.value === 1) {
            fetchtableData();
            fetchMember();
            setSelectedEvent("");
            setSelectedDropdownOption("");
        }
        else if (option.value === 2) {
            fetchtableData();
            fetchMember();
            fetchFamilyMember();
            setSelectedEvent("");
            fetchtableDataEvent();
            setExpenseOptions("");
            setIncomeOptions("");
            setSelectedDropdownOption("");
        }
        else if (option.value === 3) {
            setExpenseOptions("");
            fetchtableData();
            setSelectedEvent("");
            setIncomeOptions("");
            setSelectedDropdownOption("");
            setSelectedEvent("");
            fetchMember();
            setSelectedMember("");
            //fetchDues();

        }
        else if (option.value === 4) {
            fetchtableData();
            setSelectedEvent("");
            fetchParty();

        }

    };

    const handlePaymentTypeChange = (options1) => {
        setPaymentType(options1);
         if (paymentType == '1' || paymentType == '2'|| paymentType == '3') {
            fetchBank();

        }
    }

    const formatDateForInput = (dateString) => {
        if (!dateString) return ''; // Handle cases where dateString is undefined or null
        const currentDate = new Date(dateString);
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        return `${day}-${month}-${year}`;
    };

    const [amountn, setAmountn] = useState(0); // Store the entered amount
    const [previousAmount, setPreviousAmount] = useState(0);

    const handleAmountChange = (e) => {
        setAmountn(e.target.value); // Update the amount state when user types
    };

    const handleAmountSubmit = () => {
        let enteredAmount = parseFloat(amountn) + parseFloat(advanceamount); // Convert entered amount to float
        if (enteredAmount > 0) {
            let remainingAmount = parseFloat(enteredAmount); // Convert entered amount to float
            const updatedDuesList = originalDuesList.map((member, index) => {
                if (remainingAmount <= 0) return member; // If remaining amount is used up, return the member as is

                let paid = 0;
                let balance = 0;
                let pending = member.pendingAmount;

                if (remainingAmount >= pending) {
                    paid = pending;
                    balance = 0;
                    remainingAmount -= paid; // Subtract the paid amount from remaining
                } else {
                    paid = remainingAmount;
                    balance = pending - paid;
                    remainingAmount = 0; // All remaining amount is used up
                }

                return {
                    ...member,
                    paidAmount: paid,
                    balanceAmount: balance,
                    pendingAmount: pending - paid,
                };
            });

            setDuesList(updatedDuesList); // Update the dues list with the modified values
        }
    };

    const handleAddClick = () => {
        // setIsModalOpen(true);
    };

    const handleDropdownChange = (dropdownOption) => {
        // setfeesType("");
        if (selectedOption?.value === 1) {
            setClubIncomeExpenseOption(dropdownOption); // Club Income/Expense
        } else if (selectedOption?.value === 2) {
            setEventHeadOption(dropdownOption); // Event Head
            fetchEventExpenseData(dropdownOption.value); // Fetch Event Income/Expense
            fetchFamilyMember();

        }
    };

    const handleIncomeExpenseChange = (dropdownOption) => {
        setEventIncomeExpenseOption(dropdownOption); // Event Income/Expense
    };

    
    const fetchDuesList = async (memberId) => {
    try {
        const response = await fetchData(
            'ReportsApi',
            `/${clubId}/${branchId}/${memberId}`,
            token
        );

        if (response.responseCode === '1111') {
            setDuesList(response.response_data);
            setOriginalDuesList(response.response_data);
            setfeesType('Monthly');
            setAdvanceAmount(response.advanceamt);
        } else {
             setAdvanceAmount(response.advanceamt);
            console.warn('Failed to fetch dues list:', response);
        }
    } catch (error) {
        console.error('Error fetching dues list:', error);
    }
};

    const handleBankChange = (dropdownOption) => {
        setSelectedBank(dropdownOption);
    };

    const handlePartyChange = (dropdownOption1) => {
        setSelectedParty(dropdownOption1);
    };

    const handleDropdownChangeEvent = (dropdownOption) => {
        setSelectedEvent(dropdownOption);
        //setEventName(dropdownOption.label);
        // fetchEventExpenseData(dropdownOption.value);  // Fetch data based on selected event
    };

    const customSelectStyles = {
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        menu: (provided) => ({
            ...provided,
            width: "auto",
            minWidth: "fit-content",
            whiteSpace: "nowrap",
            overflowX: "auto",
            overflowY: "hidden",
            maxHeight: "none"
        })
    };

    // Fetch expense or income data based on event ID and ispayment
    const fetchEventExpenseData = async (eventId) => {
        try {
            const type = 1;
            const response = await fetchEventincomeExpenseData('EventApi', `/${clubId}`, `/${eventId}`, type, token);

            if (response.responseCode === '1111') {
                const options = response.response_data.map(item => ({
                    value: item.headId,
                    label: item.description,
                }));

                setEventExpenseOptions(options);
                await Nonmembers(eventId);

            } else {
                console.warn('Unexpected response code:', response.responseCode);
            }
        } catch (error) {
            console.error('Error fetching event data:', error);

            if (error.response && error.response.status === 401) {
                //  logout();
                history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
            } else {
                console.error('An unexpected error occurred.');
            }
        }
        console.log("Fetching data for event ID:", eventId);
    };


    const Nonmembers = async (eventId) => {
        try {
            const tmpType = "nonmember"; // Or whatever string the backend uses
            const response = await fetchData1(
                'EventApi',
                `/${clubId}/${eventId}/${branchId}/5/${tmpType}`,
                token
            );

            if (response.responseCode === '1111') {
                const options2 = response.response_data.map(member => ({
                    value: member.id,
                    label: member.memberName,
                    firstName: member.memberName,
                    //lastName: member.memberName,
                    phoneNumber: member.phoneNumber,
                    email: member.remarks,
                    type: 1,
                    category:'Non-Member',

                }));

                setMemberOptions(prev => [...prev, ...options2]);
                setMemberList(options);
            }
        } catch (error) {
            console.error('Error fetching Member:', error);
        }
    };


    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            fetchBank();
            logout();
            return;
        }

    }, [isAuthenticated, clubId, token, logout]);

    useEffect(() => {
        fetchtableData();
    }, []);


    const fetchtableData = async () => {
        try {
            const response = await fetchDataAccountsIncomeExpense('AccountHeadApi', `/${clubId}`, ispayment, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(incomeexpense => ({
                    value: incomeexpense.id,
                    label: incomeexpense.head,
                    isEvent: incomeexpense.isEvent
                }));
                if (ispayment) {
                    setExpenseOptions(options);  // Store in expense list
                    const filteredOptions = options.filter(option => option.isEvent === true);
                    setEventHeadExpenseOptions(filteredOptions);

                } else {
                    setExpenseOptions(options);

                    setIncomeOptions(options);   // Store in income list
                    const filteredOptions = options.filter(option => option.isEvent === true);
                    setEventHeadIncomeOptions(filteredOptions);

                }

            }
            else {
                console.warn('Unexpected response code:', response.responseCode);
                // Handle other response codes if needed
            }
        } catch (error) {
            console.error('Error fetching AccountHead Details:', error);

            // Handle unauthorized error
            if (error.response && error.response.status === 401) {
                //logout();
                history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
            } else {
                // Handle other errors, if any
                console.error('An unexpected error occurred.');
            }
        }
    };

    const fetchtableDataEvent = async () => {
        fetchData('EventApi', `/${branchId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    const options = response.response_data.map(events => ({
                        value: events.id,
                        label: events.event

                    }));
                    setEventOptions(options);
                }
            })
            .catch((error) => {
                console.error('Error fetching Event Details:', error);
            });


    };


    const clearForm = () => {
        // setBillNo(""); setBillDate("");
        //  setAmount(""); setIsPayment("");
        // setType(""); setIncomeExpenseId("");
        //  setEventId(""); setMemberId("");
        //  setDues("");
        ///  setFeesDescriptionId(""); setPartyId("");
        //  setDescription(""); setChequeNo("");
        //  setChequeDate(""); setBankId("");
        //  setMemberOptions(""); setSelectedMember("");
        //  setEventOptions("");
        // setSelectedEvent("");
        // setFeesOptions("");
        // setSelectedFees("");
        // setPartyOptions(""); setSelectedParty("");
        //  setBankOptions(""); setSelectedBank("");


    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        setIsSubmit(true);
        submitData(e);

    }

    

    const submitData = async (e) => {
        e.preventDefault();

        if (!isSubmit) {
            setIsSubmit(true);
        }

        if (!billNo) {
            setErrorMessage("All fields are required!");
            setIsSubmit(false);
            return;
        }

        let childData = []; // Initialize an empty array for child data

        // Check if dues list has values and paymentType is Monthly
        if (feesype === 'Monthly' && dueslist && dueslist.length > 0) {
            // Filter the dues list where billAmount is not equal to balanceAmount
            const filteredDues = dueslist.filter(
                (dues) => dues.billAmount !== dues.balanceAmount
            );

            if (filteredDues.length > 0) {
                // Prepare the child data for entries that need to be saved
                childData = filteredDues.map((dues) => {
                    return {
                        BillNo: billNo,
                        BillDate: dues.billDate || "", // Use dues' billDate
                        Amount: parseFloat(dues.billAmount), // Only the balance amount
                        FeesDescriptionId: dues.feesDescriptionId || selectedfees?.value || null,
                        PendingAmount: dues.pendingAmount,
                        PaidAmount: dues.paidAmount,
                        BalanceAmount: dues.balanceAmount,
                        IsActive: true,
                        CreatedBy: userId || "",
                        CreatedDate: new Date(),
                        BillId: dues.billId,
                        FeesId: dues.feesId || null,
                        // Add any other relevant fields for the child data
                    };
                });
            }
        }

        // Master data object to send
        const masterdata = {
            BillNo: billNo,
            BillDate: billDate || "",
            Amount: parseFloat(amountn),
            IsPayment: ispayment,
            Type: selectedOption.value,
            IncomeOrExpenseId:
                  (selectedOption.value === 1 || selectedOption.value === 4)
                      ? clubIncomeExpenseOption?.value || null
                         : eventIncomeExpenseOption?.value || null,

            EventId: selectedOption.value === 2 ? eventHeadOption?.value || null : null,
            EventIncomeExpenseId: selectedOption.value === 2 ? eventIncomeExpenseOption1?.value || null : null,
            MemberId: selectedMember?.value || null,
            MemberType: selectedMember?.type || null,
            Dues: dues || null,
            FeesDescriptionId: selectedfees?.value || null,
            PartyId: selectedParty?.value || selectedMember?.value ||null,
            Description: description || "",
            ChequeNo: chequeNo || "",
            IsActive: true,
            ChequeDate: chequeDate || null,
            BankId: selectedbank?.value || null,
            CreatedBy: userId || "",
            CreatedDate: new Date(),
            ClubId: clubId || null,
            BranchId: branchId,
            Bank: '',
            Event: '',
            Member: '',
            Party: '',
            clubIncomeExpense: '',
            eventIncomeExpense: '',
            Fees: '',
            FinancialYear: '',
            PaymentType: paymentType.value,
            BillNoType: "V",
            BillNo1: 1,
            Head: selectedOption.value === 1
                ? clubIncomeExpenseOption.label
                : selectedOption.value === 2
                    ? eventHeadOption.label
                    : selectedOption.value === 3
                        ? "Fees"
                        : selectedOption.value === 4
                            ? clubIncomeExpenseOption.label
                            : null,
        };

        // Prepare the object to send to the API (master data + child data)
        const PRAndChild = {
            PRMasterData: masterdata,
            PRChildData: childData, // Send empty array even if no child data
        };

        try {
            // Post data to the API
            const response = await postData('PaymentAndReceiptApi', PRAndChild, token);
            console.log('Payment & Receipt Created success:', response);
            setSuccessMessage("Payment & Receipt Created successfully!");
            setErrorMessage("");
            clearForm();
            setTimeout(() => {
                setSuccessMessage("");
            }, 3000);
            window.location.reload();
        } catch (error) {
            console.error('Payment & Receipt Create error:', error);
            setErrorMessage("An error occurred while saving the data.");
        } finally {
            setIsSubmit(false);
        }
    };

    const [memberList, setMemberList] = useState([]);
    const [showTable, setShowTable] = useState(false);

    const fetchMember = async () => {
        try {

            const response = await fetchData1('MemberApi', `/${clubId}/${branchId}`, token);

            if (response.responseCode === '1111') {

                const options = response.response_data.map(member => ({
                    value: member.id,
                    firstName: member.firstName,
                    lastName: member.lastName,
                    phoneNumber: member.phoneNumber,
                    email: member.email,
                    type: 2,
                    category:'Member'

                }));
                setMemberOptions(options);
                setMemberList(options);
            }
        } catch (error) {
            console.error('Error fetching Member:', error);
        }
    };

    const fetchFamilyMember = async () => {
        try {

            const response = await fetchData1('FamilyMemberApi', `/${clubId}/${branchId}`, token);

            if (response.responseCode === '1111') {

                const options1 = response.response_data.map(member => ({
                    value: member.id,
                    firstName: member.name,
                   // lastName: 'Family-Member',
                    //phoneNumber: member.phoneNumber,
                   // email: member.email,
                    type: 3,
                    category: `Family-Member - ${member.relation}`,

                }));
                setMemberOptions(prev => [...prev, ...options1]);
                setMemberList(options1);
            }
        } catch (error) {
            console.error('Error fetching Member:', error);
        }
    };

    // const handleRowClick = (member) => {
    //     const selectedOption = { value: member.value, label: `${member.firstName} ${member.lastName}`, type: member.type };
    //     setmemberFinancialYear(member.financialYear);
    //     setSelectedMember(selectedOption);
    //     setSearchTerm(selectedOption.label); // Display the selected name in the search box
    //     setMemberId(selectedOption.value);
    //     setIsModalOpen(false); // Close modal after selecting a member
    //      await fetchDuesList(member.id);
    // };


    const handleRowClick = async (member) => {
    const selectedOption = {
        value: member.value,
        label: `${member.firstName} ${member.lastName}`,
        type: member.type
    };

    setmemberFinancialYear(member.financialYear);
    setSelectedMember(selectedOption);
    setSearchTerm(selectedOption.label);
    setMemberId(member.value);
    setIsModalOpen(false);

    // Fetch dues list immediately
    await fetchDuesList(member.value);
};

    const filteredMembers = memberOptions.filter((member) =>
        `${member.firstName} ${member.lastName}`.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const fetchFees = async () => {
        try {
            // const response = await fetchData('ClubFeesApi', `/${clubId}`, token)
            const response = await fetchData1('ClubFeesApi', `/c/${clubId}/${branchId}/${1}`, token)
            if (response.responseCode === '1111') {

                const options = response.response_data.map(fees => ({
                    value: fees.id,
                    label: fees.feesDescription,
                    monthly: fees.isOneTime,


                }));
                setFeesOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Fees:', error);
        }
    };

    const fetchParty = async () => {
        try {
            const response = await fetchData('PersonApi', `/${branchId}`, token)
            if (response.responseCode === '1111') {

                const options = response.response_data.map(party => ({
                    value: party.id,
                    label: party.name,

                }));
                setPartyOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Fees:', error);
        }
    };

    const fetchBank = async () => {
        try {
            const response = await fetchData('PersonApi', `/${branchId}`, token);

            if (response.responseCode === '1111') {
                const options = response.response_data
                    .filter(party => party.isBank === true) // Filter for items where isBank is true
                    .map(party => ({
                        value: party.id,
                        label: party.name,
                    }));

                setBankOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Fees:', error);
        }
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setIsModalOpen(true); // Open modal when typing in the search box
        fetchFees();
    };

    const handleMemberChange = (dropdownOption) => {
        setSelectedMember(dropdownOption);
        fetchFees();
        setIsModalOpen(true); // Open modal when dropdown changes
    };

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);
    //const closeModal = () => setIsModalOpen(false);
    const [selectedDropdownOption, setSelectedDropdownOption] = useState(null);

    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-2 mx-auto" style={{ maxWidth: '95%' }}>
                <form onSubmit={handleFormSubmit}>
                    <div className="w-full flex justify-between items-center flex-wrap">
                        {/* Heading on the left */}
                        <h6 className='productHead linkcolor'
                            style={{ color: 'black', padding: '7px', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
                            PAYMENTS & RECEIPT CREATE
                        </h6>
                        <div className="w-1/10 mr-2">
                            <div className="flex items-center">
                                <input
                                    type="radio"
                                    id="ispayment"
                                    name="entityTypeEdit"
                                    value="ispayment"
                                    checked={ispayment}
                                    onChange={() => {
                                        setIsPayment(true)
                                        setSelectedOption("");



                                    }}
                                />
                                <label htmlFor="onetimeEdit" className="ml-2">Payment</label>

                                <input
                                    type="radio"
                                    id="ispayment"
                                    name="entityTypeEdit"
                                    value="ispayment"
                                    checked={!ispayment}
                                    onChange={() => {
                                        setIsPayment(false)
                                        setSelectedOption("");
                                    }}
                                    className="ml-4"
                                />
                                <label htmlFor="ispayment" className="ml-2">Receipt</label>
                            </div>
                        </div>

                        {/* Buttons on the right */}
                        <div className="flex mt-2">
                            <Button onClick={handleFormSubmit} style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#0e728c' }}>
                                Save
                            </Button>
                            <Button style={{ color: 'white', fontWeight: 'bolder', backgroundColor: '#0e728c', marginLeft: '5px' }}>
                                <Link to="/PRIndex" className="linkcolor" style={{ textDecoration: 'none', color: 'inherit' }}>
                                    CANCEL
                                </Link>
                            </Button>
                        </div>
                    </div>

                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}

                    <div className="w-full flex flex-wrap">
                        {/* <div className="w-full sm:w-3/5"> */}
                        <div className="w-full mb-2 flex">
                            <div className="w-1/10 mr-2" style={{ width: '100px' }}>
                                <label htmlFor="billNo">Bill No</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={billNo}
                                    onChange={(e) => setBillNo(e.target.value)}
                                    type="text"
                                    placeholder="Enter Bill No"

                                />
                            </div>
                            <div className="w-1/10 mr-2" style={{ width: '150px' }}>
                                <label htmlFor="billDate">Bill Date</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                    value={billDate}
                                    onChange={(e) => setBillDate(e.target.value)}
                                    type="date"
                                    placeholder="Select Bill Date"
                                />
                            </div>

                            <div className="w-1/10 mr-2" style={{ width: '170px' }}>
                                <label htmlFor="amount">Amount</label>
                                <input
                                    className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                    value={amountn}
                                    onChange={handleAmountChange}
                                    type="TEXT"
                                    placeholder="Enter Amount"
                                    onKeyDown={(e) => e.key === 'Enter' && handleAmountSubmit()} // Submit when Enter is pressed
                                />
                            </div>

                           <div className="w-1/10 mr-2" style={{ width: '100px' }}>
                                <label htmlFor="billNo">Advance Amt</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                    value={advanceamount}
                                    onChange={(e) => setAdvanceAmount(e.target.value)}
                                    type="text"
                                  />
                            </div>

                            <div className="w-1/5 mr-2" >
                                <label htmlFor="clubOptions">
                                    Club Options
                                </label>
                                <Select
                                    value={selectedOption}
                                    onChange={(option) => handleOptionChange(option)}
                                    options={options}
                                    placeholder="Select an option"
                                    isSearchable
                                    menuPortalTarget={document.body} // Ensures dropdown renders outside its parent
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        control: (provided) => ({
                                            ...provided,
                                            width: "260px", // Default fixed width
                                            minWidth: "200px", // Prevents shrinking smaller than this
                                            maxWidth: "auto", // Expands if needed
                                            cursor: "pointer",
                                            whiteSpace: "nowrap"
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            width: "auto",
                                            minWidth: "260px",
                                            whiteSpace: "nowrap",
                                            overflowX: "auto", // Allows horizontal scrolling if needed
                                            overflowY: "hidden", // Disables vertical scrolling
                                            maxHeight: "none"
                                        }),

                                    }}
                                />

                            </div>

                            {(selectedOption?.value === 1||selectedOption?.value === 4) && (
                                <div className="w-1/3 mr-2">
                                    <label htmlFor="clubIncomeExpenseOption" >
                                        {ispayment ? 'Expense Head' : 'Income Head'}
                                    </label>
                                    <div className="flex items-center">
                                        <Select
                                            value={clubIncomeExpenseOption}
                                            onChange={(option) => setClubIncomeExpenseOption(option)}
                                            options={ispayment ? expenselist : incomelist}
                                            placeholder={ispayment ? 'Expense head' : 'Income head'}
                                            isSearchable
                                            menuPortalTarget={document.body} // Ensures dropdown renders outside its parent
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                control: (provided) => ({
                                                    ...provided,
                                                    width: "300px", // Default fixed width
                                                    minWidth: "200px", // Prevents shrinking smaller than this
                                                    maxWidth: "auto", // Expands if needed
                                                    cursor: "pointer",
                                                    whiteSpace: "nowrap"
                                                }),
                                                menu: (provided) => ({
                                                    ...provided,
                                                    width: "auto",
                                                    minWidth: "300px",
                                                    whiteSpace: "nowrap",
                                                    overflowX: "auto", // Allows horizontal scrolling if needed
                                                    overflowY: "hidden", // Disables vertical scrolling
                                                    maxHeight: "none"
                                                }),

                                            }}
                                        />
                                    </div>
                                </div>
                            )}

                        </div>

                        <div className="w-full flex flex-wrap">

                            {selectedOption?.value === 2 && (
                                <div className="w-1/10 mr-2">
                                    <label htmlFor="eventHead">Select Event</label>
                                    <Select
                                        value={eventHeadOption}
                                        onChange={handleDropdownChange}
                                        options={eventslist}
                                        placeholder="Select Event"
                                        isSearchable
                                        menuPortalTarget={document.body} // Ensures dropdown renders outside its parent
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            control: (provided) => ({
                                                ...provided,
                                                width: "300px", // Default fixed width
                                                minWidth: "200px", // Prevents shrinking smaller than this
                                                maxWidth: "auto", // Expands if needed
                                                cursor: "pointer",
                                                whiteSpace: "nowrap"
                                            }),
                                            menu: (provided) => ({
                                                ...provided,
                                                width: "auto",
                                                minWidth: "300px",
                                                whiteSpace: "nowrap",
                                                overflowX: "auto", // Allows horizontal scrolling if needed
                                                overflowY: "hidden", // Disables vertical scrolling
                                                maxHeight: "none"
                                            }),

                                        }}
                                    />
                                </div>
                            )}
                            {/* {(selectedOption?.value === 2) && (
                                <div className="w-1/10 mr-2">
                                    <label htmlFor="clubOptions">
                                        {ispayment ? 'Select Event Expense Head' : 'Select Event Income Head'}
                                    </label>
                                    <div className="flex items-center">
                                        <Select
                                            value={eventIncomeExpenseOption}
                                            onChange={(option) => setEventIncomeExpenseOption(option)}
                                            options={ispayment ? eventheadexpenselist : eventheadincomelist}
                                            // options={ispayment ? eventheadexpenselist} eventexpenselist
                                            placeholder={ispayment ? 'Choose an expense head' : 'Choose an income head'}
                                            isSearchable
                                            menuPortalTarget={document.body} // Ensures dropdown renders outside its parent
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                control: (provided) => ({
                                                    ...provided,
                                                    width: "300px", // Default fixed width
                                                    minWidth: "200px", // Prevents shrinking smaller than this
                                                    maxWidth: "auto", // Expands if needed
                                                    cursor: "pointer",
                                                    whiteSpace: "nowrap"
                                                }),
                                                menu: (provided) => ({
                                                    ...provided,
                                                    width: "auto",
                                                    minWidth: "300px",
                                                    whiteSpace: "nowrap",
                                                    overflowX: "auto", // Allows horizontal scrolling if needed
                                                    overflowY: "hidden", // Disables vertical scrolling
                                                    maxHeight: "none"
                                                }),

                                            }}
                                        />
                                    </div>
                                </div>
                            )}*/}


                            {selectedOption?.value === 2 && eventHeadOption && (
                                <div className="w-1/10 mr-2">
                                    <label htmlFor="eventIncomeExpense">
                                        {ispayment ? 'Select Event Expense' : 'Select Event Income'}
                                    </label>
                                    <Select
                                        value={eventIncomeExpenseOption1}
                                        onChange={(option) => setEventIncomeExpenseOption1(option)}
                                        options={eventexpenselist}
                                        placeholder={ispayment ? 'Select Event Expense' : 'Select Event Income'}
                                        isSearchable
                                        menuPortalTarget={document.body} // Ensures dropdown renders outside its parent
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            control: (provided) => ({
                                                ...provided,
                                                width: "300px", // Default fixed width
                                                minWidth: "200px", // Prevents shrinking smaller than this
                                                maxWidth: "auto", // Expands if needed
                                                cursor: "pointer",
                                                whiteSpace: "nowrap"
                                            }),
                                            menu: (provided) => ({
                                                ...provided,
                                                width: "auto",
                                                minWidth: "300px",
                                                whiteSpace: "nowrap",
                                                overflowX: "auto", // Allows horizontal scrolling if needed
                                                overflowY: "hidden", // Disables vertical scrolling
                                                maxHeight: "none"
                                            }),

                                        }}
                                    />
                                </div>
                            )}


                            {/* select Event Member */}

                            {(selectedOption?.value === 3 || (selectedOption?.value === 1) || (selectedOption?.value === 2 && eventHeadOption)) && (
                                <div className="w-1/10 mr-2">
                                    <label htmlFor="amount">Select Member</label>
                                    <div className="flex items-center">
                                        <input
                                            type="text"
                                            id="searchMember"
                                            value={searchTerm}
                                            onChange={handleSearchChange}
                                            placeholder="Type to search members"
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        />
                                    </div>

                                    {isModalOpen && (
                                        <div className="fixed inset-0 flex items-center justify-center z-10">
                                            <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '900px', height: '490px', overflowY: 'auto' }}>
                                                <div className="flex justify-end">
                                                    <button onClick={closeModal} className="text-red-500 font-bold">Close</button>
                                                </div>

                                                {/* Member Table inside the modal */}
                                                <table className="mt-4 w-full border border-gray-300" style={{ borderCollapse: 'collapse', marginTop: '-10px' }}>
                                                    <thead sx={{ backgroundColor: '#14a3c7' }}>
                                                        <tr>
                                                            <th style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc', fontSize: '12px', textTransform: 'uppercase' }}>First Name</th>
                                                            <th style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc', fontSize: '12px', textTransform: 'uppercase' }}>Last Name</th>
                                                            <th style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc', fontSize: '12px', textTransform: 'uppercase' }}>Phone Number</th>
                                                            <th style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc', fontSize: '12px', textTransform: 'uppercase' }}>Email</th>
                                                            <th style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc', fontSize: '12px', textTransform: 'uppercase' }}>Category</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {filteredMembers.map((member) => (
                                                            <tr
                                                                key={member.id}
                                                                onClick={() => handleRowClick(member)}
                                                                className="cursor-pointer hover:bg-gray-200"
                                                                style={{ borderBottom: '1px solid #ddd' }}
                                                            >
                                                                <td style={{ padding: '3px', border: '1px solid #ccc', fontSize: '12px' }}>{member.firstName}</td>
                                                                <td style={{ padding: '3px', border: '1px solid #ccc', fontSize: '12px' }}>{member.lastName}</td>
                                                                <td style={{ padding: '3px', border: '1px solid #ccc', fontSize: '12px' }}>{member.phoneNumber}</td>
                                                                <td style={{ padding: '3px', border: '1px solid #ccc', fontSize: '12px' }}>{member.email}</td>
                                                                <td style={{ padding: '3px', border: '1px solid #ccc', fontSize: '12px' }}>{member.category}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}

                         

                            {selectedOption?.value === 3 && (
                                <div style={{ width: '150px' }}>
                                    <label htmlFor="billDate">Dues</label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                        value={dues}
                                        onChange={(e) => setDues(e.target.value)}
                                        type="text"
                                        placeholder="Dues"
                                    />
                                </div>
                            )}

                            {selectedOption?.value === 4 && (
                                <div className="w-1/10 mr-2">
                                    <label htmlFor="amount">Select Party</label>
                                    <div className="flex items-center">
                                        <Select
                                            value={selectedParty}
                                            onChange={handlePartyChange}
                                            options={partylist}
                                            placeholder="Select Party"
                                            isSearchable
                                            menuPortalTarget={document.body} // Ensures dropdown renders outside its parent
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                menu: (provided) => ({
                                                    ...provided,
                                                    width: "auto", // Auto-adjust width based on content
                                                    minWidth: "fit-content",
                                                    whiteSpace: "nowrap", // Prevent text wrapping
                                                    overflowX: "auto", // Allow horizontal scrolling
                                                    overflowY: "hidden", // Disable vertical scrolling
                                                    maxHeight: "none" // Prevent height restrictions
                                                })
                                            }}
                                        />
                                    </div>
                                </div>
                            )}

                            <div className="w-1/10 mr-2">
                                <label htmlFor="paymentType" className="mr-2">Payment Type</label>
                                <Select
                                    value={options1.find(option => option.value === paymentType)} // Find the option that matches the current paymentType
                                    onChange={handlePaymentTypeChange}
                                    options={options1}
                                    placeholder="Select Payment Type"
                                    isSearchable
                                    menuPortalTarget={document.body} // Ensures dropdown renders outside its parent
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        menu: (provided) => ({
                                            ...provided,
                                            width: "auto", // Auto-adjust width based on content
                                            minWidth: "fit-content",
                                            whiteSpace: "nowrap", // Prevent text wrapping
                                            overflowX: "auto", // Allow horizontal scrolling
                                            overflowY: "hidden", // Disable vertical scrolling
                                            maxHeight: "none" // Prevent height restrictions
                                        })
                                    }}
                                />
                            </div>

                            <div className="w-1/3 mr-4">
                                <label htmlFor="amount">Description</label>
                                <textarea
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    placeholder="Enter Description"
                                    rows="1" // Optional: Adjusts the height of the textarea (number of rows)
                                />
                            </div>
                        </div>

                        {selectedOption?.value === 3 && !ispayment && (
                            <div className="mt-4" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                <table className="w-full border border-gray-300" style={{ borderCollapse: 'collapse' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc', position: 'sticky', top: '0', zIndex: 1, fontSize: '12px', textTransform: 'uppercase' }}>Bill Date</th>
                                            <th style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc', position: 'sticky', top: '0', zIndex: 1, fontSize: '12px', textTransform: 'uppercase' }}>Fees Description</th>
                                            <th style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc', position: 'sticky', top: '0', zIndex: 1, fontSize: '12px', textTransform: 'uppercase' }}>Bill Amount</th>
                                            <th style={{ backgroundColor: '#f3f3f3', padding: '3px', display: 'none', border: '1px solid #ccc', position: 'sticky', top: '0', zIndex: 1, fontSize: '12px', textTransform: 'uppercase' }}>Pending Amount</th>
                                            <th style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc', position: 'sticky', top: '0', zIndex: 1, fontSize: '12px', textTransform: 'uppercase' }}>Paid Amount</th>
                                            <th style={{ backgroundColor: '#f3f3f3', padding: '3px', border: '1px solid #ccc', position: 'sticky', top: '0', zIndex: 1, fontSize: '12px', textTransform: 'uppercase' }}>Balance Amount</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {dueslist.map((member) => (
                                            <tr
                                                key={member.feesId}
                                                onClick={() => handleRowClick(member)}
                                                className="cursor-pointer hover:bg-gray-200"
                                                style={{ borderBottom: '1px solid #ddd' }}
                                            >
                                                <td style={{ padding: '3px', border: '1px solid #ccc', fontSize: '12px' }}>{formatDateForInput(member.billDate)}</td>
                                                <td style={{ padding: '3px', border: '1px solid #ccc', fontSize: '12px' }}>{member.feeDescription}</td>
                                                <td style={{ padding: '3px', border: '1px solid #ccc', textAlign: 'right', fontSize: '12px' }}>{member.billAmount}</td>
                                                <td style={{ padding: '3px', border: '1px solid #ccc', display: 'none', fontSize: '12px' }}>{member.pendingAmount}</td>
                                                <td style={{ padding: '3px', border: '1px solid #ccc', textAlign: 'right', fontSize: '12px' }}>{member.paidAmount}</td>
                                                <td style={{ padding: '3px', border: '1px solid #ccc', textAlign: 'right', fontSize: '12px' }}>{member.balanceAmount}</td>


                                            </tr>
                                        ))}

                                        {/* Calculate the total balance at the bottom */}
                                        <tr>
                                            <td colSpan="4" style={{ textAlign: 'right', padding: '3px', borderTop: '2px solid #ccc', fontSize: '12px' }}>Total Balance:</td>
                                            <td style={{ padding: '3px', borderTop: '2px solid #ccc', fontSize: '12px' }}>
                                                {/* Calculate the total of balanceAmount */}
                                                {dueslist.reduce((total, member) => total + parseFloat(member.balanceAmount || 0), 0)}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>



                    <div className="w-full flex flex-wrap items-center gap-2">
                        {paymentType?.value === '1' && (
                            <div className="w-1/4">
                                <label htmlFor="chequeNo" className="text-sm">Cheque No</label>
                                <input
                                    className="border rounded px-2 py-1 text-gray-700 focus:ring-1 focus:ring-cyan-500 w-full text-sm"
                                    value={chequeNo}
                                    onChange={(e) => setChequeNo(e.target.value)}
                                    type="text"
                                    placeholder="Cheque No"
                                />
                            </div>
                        )}

                        {(paymentType?.value === '2' || paymentType?.value === '3') && (
                            <div className="w-1/4">
                                <label htmlFor="referenceNo" className="text-sm">Reference No</label>
                                <input
                                    className="border rounded px-2 py-1 text-gray-700 focus:ring-1 focus:ring-cyan-500 w-full text-sm"
                                    value={chequeNo}
                                    onChange={(e) => setChequeNo(e.target.value)}
                                    type="text"
                                    placeholder="Reference No"
                                />
                            </div>
                        )}

                        {(paymentType?.value === '1' || paymentType?.value === '2' || paymentType?.value === '3') && (
                            <div className="w-1/5">
                                <label htmlFor="chequeDate" className="text-sm">Date</label>
                                <input
                                    className="border rounded px-2 py-1 text-gray-700 focus:ring-1 focus:ring-cyan-500 w-full text-sm"
                                    value={chequeDate}
                                    onChange={(e) => setChequeDate(e.target.value)}
                                    type="date"
                                />
                            </div>
                        )}

                        {(paymentType?.value === '1' || paymentType?.value === '2' || paymentType?.value === '3') && (
                            <div className="w-1/4">
                                <label htmlFor="bank" className="text-sm">Bank</label>
                                <Select
                                    value={selectedbank}
                                    onChange={handleBankChange}
                                    options={banklist}
                                    placeholder="Select Bank"
                                    isSearchable
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        menu: (provided) => ({
                                            ...provided,
                                            width: "auto",
                                            minWidth: "fit-content",
                                            whiteSpace: "nowrap",
                                            overflowX: "auto",
                                            overflowY: "hidden",
                                            maxHeight: "none",
                                        }),
                                    }}
                                />
                            </div>
                        )}
                    </div>
                    {/* <div className="w-full flex flex-wrap items-center gap-2">
                        <div className="w-1/2 mr-4">
                            <label htmlFor="amount">Description</label>
                            <textarea
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                placeholder="Enter Description"
                                rows="1" // Optional: Adjusts the height of the textarea (number of rows)
                            />
                        </div>
                    </div> */}
                </form>
            </div>
        </Fragment>


    );
}

export default PRCreate;




